module.exports = __webpack_public_path__ + "static/img/Five of Cups.6fcf8cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Five of Cups.jpg
// module id = 1265
// module chunks = 0